export function HorizontalLine({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      fill='none'
      height='2'
      id='horizontal-line'
      viewBox='0 0 782 2'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M1 1H781' stroke='#C4C2C1' strokeDasharray='0.01 6' strokeLinecap='round' strokeWidth='2' />
    </svg>
  );
}

export function VerticalLine({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      fill='none'
      height='2'
      id='vertical-line'
      viewBox='0 0 251 2'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M1 1H781' stroke='#C4C2C1' strokeDasharray='0.01 6' strokeLinecap='round' strokeWidth='2' />
    </svg>
  );
}
